import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, Grid,
         Hidden, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Switch,
         TextField, Tooltip, Typography
} from '@mui/material';

import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import HelpOutline from '@mui/icons-material/HelpOutline';

import CustomerServiceUpdateMutation from '../customer/CustomerServiceUpdateMutation';
import AppDisplay from '../ui/AppDisplay';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import SaveButton from '../ui/SaveButton';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import CurrencyTextField from '../ui/CurrencyTextField';
import ServerError from '../ui/ServerError';

import AppBindStyles from '../../AppBindStyles';

import { red, green, blue } from '@mui/material/colors';

const styleSheet = theme => ({
    root: {
      width: '100%',
    },
    statusButton: {
      color: '#444'
    },
    typeicon: {
      verticalAlign: 'middle',
    },
    listItemIcon: {
      minWidth: 28,
      width: 28
    },
    notesField: {
      marginTop: theme.spacing(1),
      // marginBottom: 6,
    },
    flexContainer: {
      display: 'flex',
      width: '100%'
    },
    flexFixed: {
      flex: 0,
      width: 104,
    },
    flexVariable: {
     flex: 1,
     marginRight: 16
    },
    paperFirst: {
        textAlign: 'left',
        color: theme.palette.text.secondary,
        maxWidth: 980,
        marginTop: 16,
        marginBottom: 0,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
    },
    paper: {
        textAlign: 'left',
        //color: theme.palette.text.secondary,
        maxWidth: 980,
        marginTop: 32,
        marginBottom: 0,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
    },
    paperInner: {
      textAlign: 'left',
      // color: theme.palette.text.secondary,
      // maxWidth: 980,
      // marginTop: 8,
      padding: theme.spacing(2)
    },
    savesnackbar: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: green[300]
    },
    currencyField: {
      width: 120,
      marginTop: 4,
      marginBottom: 4
    },
    frequency: {
      width: 120,
      marginTop: 4,
      marginBottom: 4
    },
    dayOfMonth: {
      width: 185,
      marginTop: 4,
      marginLeft: 4,
      textAlign: "right"
    }
    /*
    [theme.breakpoints.up('xs')]: {
      paper: {
        padding: theme.spacing(1)
      },
      paperFirst: {
        padding: theme.spacing(1)
      }
    },
    [theme.breakpoints.up('sm')]: {
      paper: {
        padding: theme.spacing(2)
      },
      paperFirst: {
        padding: theme.spacing(2)
      }
    },
    [theme.breakpoints.up('md')]: {
      paper: {
        padding: theme.spacing(3)
      },
      paperFirst: {
        padding: theme.spacing(3)
      }
    }
    */
});

const abEnvironment = new AbEnvironment();
const ServiceManageQuery = graphql`
query ServiceManageQuery($customerServiceId: UUID!) {
  customerServiceTByCustomerServiceId(customerServiceId: $customerServiceId) {
    customerServiceId
    appId
    customerAccountId
    parentAppId
    serviceStatus
    appSkuPrice
    notes
    paymentOrder
    passThroughFees
    billingFrequency
    billingDayOfMonth
    soEntered
    soAccepted
    oneTimeBilled
    appTByAppId {
      appName
      appSku
      appUrl
      appLogo
      appType
      description
      signupUrl
      appTByOemAppId {
        appId
      }
    }
    accountTByCustomerAccountId {
      accountName
      accountId
      accountType
      contactEmail
      contactFirstName
      contactLastName
      contactEmail
      useBudgets
      latestBudgetApproved
    }
  }
}
`;

class ServiceManage extends Component {
  constructor(props)
  {
    super(props);

    this.state = {
      showSpinner:          false,
      confirmCancel:        false,
      confirmSuspend:       false,
      confirmUnsuspend:     false,
      serviceStatus:        null,
      appSkuPrice:          null,
      billingFrequency:     null,
      notes:                null,
      paymentOrder:         null,
      paymentOrderMenu:     null,
      anchorEl:             null,
      forceFetch:           0,
      passThroughFees:      null,
      saveStatus:           null,
      saveMessage:          null,
      saveSnackbarOpen:     false,
      saveSnackbarDuration: null,
      fromCreateSB:         false,
      backButtonText:       null,
      appBindAddress:       null
    };
  }

  componentDidMount() {
 
   }


  handleMenuClose = () => {
    this.setState({anchorEl: null});
  }
  handleMenuClick = event => {
    this.setState({anchorEl: event.currentTarget});
  }



  disableSave(serviceProps) {
    if (serviceProps === null)
      return true;


    let retval = this.disableAttributeCheck(this.state.serviceStatus,       serviceProps.serviceStatus) &&
                 this.disableAttributeCheck((this.state.appSkuPrice ? Number(this.state.appSkuPrice) : null),   Number(serviceProps.appSkuPrice)) &&
                 this.disableAttributeCheck(this.state.notes,               serviceProps.notes) &&
                 this.disableAttributeCheck(this.state.paymentOrder,        serviceProps.paymentOrder) &&
                 this.disableAttributeCheck(this.state.billingFrequency,    serviceProps.billingFrequency) &&
                 this.disableAttributeCheck(this.state.passThroughFees,     serviceProps.passThroughFees);



    if (this.areFieldsInError()) {
      return true;
    }

    return retval;
  }

  disableAttributeCheck(stateVar, propsVar)
  {
    if (stateVar !== null)
    {
      if (propsVar === null && stateVar === '')
        return true;

      if (propsVar !== stateVar)
        return false;
    }
    return true;
  }

  showSpinner() {
    return this.state.showSpinner;
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  // For select render, use the paymentOrderMenu state value
  // - that might not have been set.  In this case, derive the value
  //   from the paymentOrder state. If that hasn't been set,
  //   derive the value from the property that was sent in.
  getValueForSelectRender(propPaymentOrder) {
    if (this.state.paymentOrderMenu != null) {
      return this.state.paymentOrderMenu;
    }

    if (this.state.paymentOrder != null) {
      if (this.state.paymentOrder <= 1) {
        return 1;
      }
      else {
        return 2;
      }
    }

    if (propPaymentOrder != null) {
      if (propPaymentOrder <= 1) {
        return 1;
      } else {
        return 2;
      }
    }

    return 1;
  }

  goBack() {
    this.props.history.goBack();
  }

  handleCheckChange() {
    if (this.state.paymentOrder === 1) {
      this.setState({ paymentOrder: 0 });
    } else {
      this.setState({ paymentOrder: 1 });
    }
  }

  togglePassThroughFees(passThroughFees) {
    if (passThroughFees === 1) {
      this.setState({ passThroughFees: 0 });
    } else {
      this.setState({ passThroughFees: 1 });
    }
  }
    

  getValueForBillingFrequencyRender(propBillingFrequency) {
    if (this.state.billingFrequency != null) {
      return this.state.billingFrequency;
    }

    if (propBillingFrequency != null) {
      return propBillingFrequency;
    }

    return 0;
  }

  getErrorMessage(field, minValue, maxValue) {
    let errMesg = null;

    let value = Number(field); 
    if (value < minValue) {
      return 'Cannot be less than ' + minValue;
    }
    if (value > maxValue) {
      return 'Cannot be greater than ' + maxValue;
    }

    return errMesg;
  }

  areFieldsInError() {
    if (this.state.appSkuPrice !== null && this.getErrorMessage(this.state.appSkuPrice, 1, 9999) !== null) {
      return true;
    }
    return false;

  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedCustomer, needAssent, logError, getMaxServiceAmount } = this.props.auth;
    const classes = this.props.classes;
    const cancelColor   = red[300];
    const suspendColor  = blue[300];
    const okColor       = green[300];
    //const transferColor = purple[800];

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedCustomer()) {
      const params = new URLSearchParams(this.props.location.search);
      let customerServiceId = params.get('customerServiceId');

       let fp = params.get('fp');
      let backTo = "customer";
      if (fp != null && fp !== '') {
        backTo = fp;
      }
      if (this.state.backButtonText) {
        backTo = this.state.backButtonText;
      }
      //certain cases call for hiding of back button
      let hideback = false;
      
      if (params.get('hideback')) {
        hideback = true;
      } 

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={ServiceManageQuery}
          variables={{customerServiceId: customerServiceId, forceFetch: this.state.forceFetch}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              if (props.customerServiceTByCustomerServiceId === null)
              {
                return (
                  <div className={classes.root}>
                    <PageTitle title="Service not found" showBackButton={true} name={backTo} history={this.props.history}/>
                  </div>
                );
              }

              let theService = props.customerServiceTByCustomerServiceId;
              let theApp = theService.appTByAppId;
              let customerAccountName = theService.accountTByCustomerAccountId.accountName;

              let isServiceSuspended = false;
              if (theService.serviceStatus === 1) {
                isServiceSuspended = true;
              }

              let isServiceCancelled = false;
              if (theService.serviceStatus === 2) {
                isServiceCancelled = true;
              }

              /*let waitingOnApproval = false;
              if (theService.accountTByCustomerAccountId.latestBudgetApproved === 0) {
                if (theService.soEntered === 1 && theService.soAccepted === 0) {
                  waitingOnApproval = true;
                }
              }*/

              let editingDisabled = true;


              let showNotesSection = true;
 
              let passThroughFees   = this.getValueForRender(this.state.passThroughFees, theService.passThroughFees, 1);

              let cancelConfirmMessage = 'Cancelling this service will stop it from being billed. Do you wish to proceed?';

              let suspendConfirmMessage = 'Suspending this service will stop it from being billed while the service is suspended. Do you wish to proceed?';
              let unsuspendConfirmMessage = 'Unsuspending this service will start to billed again. Do you wish to proceed?';
              if (theService.billingFrequency === 0) {
                unsuspendConfirmMessage = 'This will unsuspend this service but it has already been billed as a one time fee. Do you wish to proceed?';
              }

              let pTitle = 'Service ' + theApp.appName  + ' for ' + theService.accountTByCustomerAccountId.accountName;

              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    {!hideback &&
                    <PageTitle title={pTitle} showBackButton={true} name={backTo} noMargin={true} history={this.props.history}/>}
                    {hideback &&
                    <PageTitle title={pTitle} noMargin={true} history={this.props.history}/>}
                  </Grid>

                  <Grid item xs={12}>
                    <Paper className={classes.paperFirst}>
                      <Grid container spacing={2} direction="row" >
                        <Grid item xs={12} >
                          <Grid container spacing={0} direction="row-reverse" justifyContent='space-between' alignItems='flex-start'>

                            {!isServiceCancelled && !isServiceSuspended &&
                            <Grid item>
                              <Button color="secondary" 
                                aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                aria-haspopup='true'
                                onClick={this.handleMenuClick}
                                className={classes.statusButton}
                              >
                                <CheckCircle htmlColor={okColor} /><Hidden only={['xs', 'sm']}>&nbsp;&nbsp;Active&nbsp;</Hidden><ArrowDropDown />
                              </Button>
                              <Menu
                                id="action-menu"
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleMenuClose}>
                                <MenuItem onClick={() => {this.setState({anchorEl: null, confirmSuspend:true}); }}>
                                  <ListItemIcon className={classes.listItemIcon}>
                                    <PauseCircleFilled htmlColor={suspendColor}/>
                                  </ListItemIcon>
                                  <ListItemText primary="Suspend"/>
                                </MenuItem>
                                <MenuItem onClick={() => {this.setState({anchorEl: null, confirmCancel:true}); }}>
                                  <ListItemIcon className={classes.listItemIcon}>
                                    <Cancel htmlColor={cancelColor}/>
                                  </ListItemIcon>
                                  <ListItemText primary="Cancel"/>
                                </MenuItem>
                              </Menu>
                            </Grid>}


                            { isServiceSuspended &&
                            <Grid item>
                              <Button color="secondary" 
                                aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                aria-haspopup='true'
                                onClick={this.handleMenuClick}
                                className={classes.statusButton}
                              >
                                <PauseCircleFilled htmlColor={suspendColor} /><Hidden only={['xs', 'sm']}>&nbsp;&nbsp;Suspended&nbsp;</Hidden><ArrowDropDown />
                              </Button>
                              <Menu
                                id="action-menu"
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleMenuClose}>
                                <MenuItem onClick={() => {this.setState({anchorEl: null, confirmUnsuspend:true}); }}>
                                  <ListItemIcon className={classes.listItemIcon}>
                                    <PlayCircleFilled htmlColor={okColor}/>
                                  </ListItemIcon>
                                  <ListItemText primary="Unsuspend"/>
                                </MenuItem>
                                <MenuItem onClick={() => {this.setState({anchorEl: null, confirmCancel:true}); }}>
                                  <ListItemIcon className={classes.listItemIcon}>
                                    <Cancel htmlColor={cancelColor}/>
                                  </ListItemIcon>
                                  <ListItemText primary="Cancel"/>
                                </MenuItem>
                              </Menu>
                            </Grid>}

                            { isServiceCancelled &&
                            <Grid item>
                              <Button color="primary" disabled={true}>
                                <Cancel htmlColor={cancelColor} /><Hidden only={['xs', 'sm']}>&nbsp;Cancelled&nbsp;</Hidden>
                              </Button>
                            </Grid>}

                            <Grid item xs={9} style={{marginTop: 4}}>
                              <AppDisplay appLogo={theApp.appLogo}
                                          appName={theApp.appName}
                                          appSku={theApp.appSku}
                                          description={theApp.description}
                                          appId={theService.appId}
                                          history={this.props.history}
                                          fp={'Manage Subscription'}/>
                            </Grid>

                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid item xs={12}>
                    <Paper className={classes.paper}>
                      <Grid container spacing={2} direction="row" >
                        <Grid item xs={12} >
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Grid container spacing={0} direction="row" justifyContent="flex-start">
                                <Grid item xs={12}>
                                  <Typography align="left" variant="h6">View terms</Typography>
                                </Grid>                          
                                <Grid item xs={12}>
                                  <Typography variant="body2">View the billing terms for this service.</Typography>
                                </Grid>
                              </Grid>
                            </Grid>


                            <Grid item xs={12}>
                              <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                                <Grid item>
                                  <Grid container direction="column" spacing={0}>
                                    <Grid item>
                                      <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Amount"}</Typography>
                                    </Grid>
                                    <Grid item style={AppBindStyles.markupDescription}> 
                                    <Typography variant="caption">{'This amount will be billed to ' + customerAccountName}</Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item > 
                                  <CurrencyTextField id="appSkuPrice" className={classes.currencyField}
                                    value={this.getValueForRender(this.state.appSkuPrice, theService.appSkuPrice, 0)}
                                    disabled={editingDisabled}
                                    showErrMsg={true}
                                    allowNegative={false}
                                    minValue={1}
                                    maxValue={getMaxServiceAmount()}
                                    minEnterValue={0}
                                    maxEnterValue={99999999}
                                    onChange={(e) => this.setState({ appSkuPrice: (e.target.value) ? e.target.value : '0' })}
                                    textAlign="right"
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                                <Grid item>
                                  <Grid container direction="column" spacing={0}>
                                    <Grid item>
                                      <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Frequency"}</Typography>
                                    </Grid>
                                    <Grid item style={AppBindStyles.markupDescription}> 
                                      <Typography variant="caption">{'Monthly billing occurs on the billing day'}</Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item > 
                                  <FormControl>
                                    <Select
                                      value={this.getValueForBillingFrequencyRender(theService.billingFrequency) }
                                      disabled={editingDisabled}
                                      className={classes.frequency}
                                      onChange={(e) => { 
                                            this.setState({ billingFrequency: e.target.value }); 
                                      } }
                                      inputProps={{
                                        name: 'billingFrequency',
                                        id: 'billingFrequency',
                                      }}
                                    >                                   
                                      <MenuItem value={0}>One-time fee</MenuItem>
                                      <MenuItem value={1}>Monthly</MenuItem>
                                      {/*<MenuItem value={2}>Annual</MenuItem>*/}
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Grid>
                            {theService.billingFrequency === 1 &&

                              <Grid item xs={12}>
                                <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                                  <Grid item>
                                    <Grid container direction="column" spacing={0}>
                                      <Grid item>
                                        <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Billing day of month"}</Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item > 
                                    <FormControl>
                                      <Select
                                        className={classes.dayOfMonth}
                                        disabled={editingDisabled}
                                        value={theService.billingDayOfMonth}
                                        inputProps={{
                                          name: 'billingDayOfMonth',
                                          id: 'billingDayOfMonth',
                                        }}
                                      >                                   
                                        <MenuItem value={0}>Day after order accepted</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                        <MenuItem value={7}>7</MenuItem>
                                        <MenuItem value={8}>8</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={11}>11</MenuItem>
                                        <MenuItem value={12}>12</MenuItem>
                                        <MenuItem value={13}>13</MenuItem>
                                        <MenuItem value={14}>14</MenuItem>
                                        <MenuItem value={15}>15</MenuItem>
                                        <MenuItem value={16}>16</MenuItem>
                                        <MenuItem value={17}>17</MenuItem>
                                        <MenuItem value={18}>18</MenuItem>
                                        <MenuItem value={19}>19</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={21}>21</MenuItem>
                                        <MenuItem value={22}>22</MenuItem>
                                        <MenuItem value={23}>23</MenuItem>
                                        <MenuItem value={24}>24</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={26}>26</MenuItem>
                                        <MenuItem value={27}>27</MenuItem>
                                        <MenuItem value={32}>Last day of month</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              </Grid>


                              }
                            {false &&
                            <Grid item xs={12}>
                              <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                                  <Grid item>
                                    <Grid container direction="column" spacing={0}>
                                      <Grid item>
                                        <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Pass payment fees to " + customerAccountName}</Typography>
                                      </Grid>
                                      <Grid item style={AppBindStyles.markupDescription}> 
                                        <Typography variant="caption">Credit card fees</Typography>
                                        <Tooltip placement='bottom' title='If funding by credit card, fees are 2.9% US and 3.9% international + $0.30'>
                                          <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                                        </Tooltip>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item>
                                    <Switch checked={passThroughFees === 1} 
                                                  disabled={editingDisabled}
                                                  onChange={(e) => this.togglePassThroughFees(passThroughFees)} 
                                                  value={passThroughFees}
                                                  color="primary"
                                    />
                                  </Grid>
                              </Grid>
                            </Grid>
                            }
                          </Grid>
                        </Grid>

                        { (showNotesSection) &&
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            
                            <Grid item xs={12}>
                              <TextField
                                id="notes" label="Notes" className={classes.notesField}
                                disabled={editingDisabled}
                                value={this.getValueForRender(this.state.notes, theService.notes, '') }
                                fullWidth
                                multiline
                                onChange={ (e) => { this.setState({ notes: e.target.value }); } }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        }

                        {/* Maintenance Buttons */}
                        <Grid item xs={12} >
                          <Grid container spacing={3} direction="row" justifyContent="space-between">
                            <Grid item>
                              <SaveButton
                                buttonStyle={AppBindStyles.bottomButtonPaper12}
                                snackbarOpen={this.state.saveSnackbarOpen}
                                autoHideDuration={this.state.saveSnackbarDuration}
                                status={this.state.saveStatus} 
                                message={this.state.saveMessage}
                                disabled={this.disableSave(theService)}
                                onSaveClick={() => { this._updateCustomerService(theService.customerServiceId); }}
                                onSnackbarClose={() => { this._onSnackbarClose(); }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>

                    <ConfirmationDialog
                        open={this.state.confirmCancel}
                        onClose={() => { this.setState({confirmCancel:false, anchorEl: null});}}
                        onConfirm={() => { this._cancelService(theService.customerServiceId);}}
                        onCancel={() => { }}
                        title="Cancel service?"
                        cancelBtn="No"
                        okBtn="Yes, cancel service"
                      >
                        {cancelConfirmMessage}
                    </ConfirmationDialog>
                    <ConfirmationDialog
                        open={this.state.confirmSuspend}
                        onClose={() => { this.setState({confirmSuspend:false, anchorEl: null});}}
                        onConfirm={() => { this._suspendService(theService.customerServiceId);}}
                        onCancel={() => { }}
                        title="Suspend service?"
                        cancelBtn="No"
                        okBtn="Yes, suspend service"
                      >
                        {suspendConfirmMessage}
                    </ConfirmationDialog>
                    <ConfirmationDialog
                        open={this.state.confirmUnsuspend}
                        onClose={() => { this.setState({confirmUnsuspend:false, anchorEl: null});}}
                        onConfirm={() => { this._unsuspendService(theService.customerServiceId);}}
                        onCancel={() => { }}
                        title="Unsuspend service?"
                        cancelBtn="No"
                        okBtn="Yes, unsuspend service"
                      >
                        {unsuspendConfirmMessage}
                    </ConfirmationDialog>
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _cancelService(customerAppId)
  {

    const { logError } = this.props.auth;

    CustomerServiceUpdateMutation.commit(customerAppId, 2,
            null, null, null, null, null, null)
    .then(data => {
      window.location.reload();
    })
    .catch(error => {
      logError('Exception in ServiceManage.js: ' + error);
    });
  }

  _suspendService(customerAppId)
  {
    const { logError } = this.props.auth;

    CustomerServiceUpdateMutation.commit(customerAppId, 1,
              null, null, null, null, null, null)
    .then(data => {
      window.location.reload();
    })
    .catch(error => {
     logError('Exception in ServiceManage.js: ' + error);
    });
  }

  _unsuspendService(customerAppId)
  {
    const { logError } = this.props.auth;

    CustomerServiceUpdateMutation.commit(customerAppId, 0,
              null, null, null, null, null, null)
    .then(data => {
      window.location.reload();
    })
    .catch(error => {
      logError('Exception in ServiceManage.js: ' + error);
    });
  }


  _updateCustomerService(customerServiceId) {


    this.setState({ saveStatus: 'saving' });

    this.setState({ showSpinner: true });
    const { serviceStatus, appSkuPrice, atId, notes, paymentOrder, passThroughFees, billingFrequency } = this.state;


    this.setState({ saveStatus: 'saving' });
            
    CustomerServiceUpdateMutation.commit(customerServiceId, serviceStatus, atId, appSkuPrice, notes, paymentOrder, billingFrequency, passThroughFees)
    .then(response => {
      this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Service saved.', saveSnackbarDuration: 3000 });
    })
    .catch(error => {
      this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save service', saveSnackbarDuration: null });
    });     
  }

  _onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }


}


ServiceManage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(ServiceManage);
